/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Link } from "gatsby";

const FooterHome = (props) => (
  <footer 
    className="site-footer-home"
    sx={{
      bg: 'primary'
    }}
  >
    <Link to="/">
      <p>Fashion Consultant</p>
    </Link>
  </footer>
)

export default FooterHome;
